import React from "react";
import BulkSelectCheckbox from "./BulkSelectCheckbox";
import { useBulkSelectionState } from "./BulkSelectionContext";

export interface BulkSelectCheckboxSlotProps {
  rowId: string;
  ariaLabel?: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Connected variant of `BulkSelectCheckbox` that pulls its selected state from
 * `BulkSelectionContext` by `rowId`. Returns `null` when no provider is
 * mounted above it so cards can render it unconditionally.
 */
const BulkSelectCheckboxSlot: React.FC<BulkSelectCheckboxSlotProps> = ({
  rowId,
  ariaLabel,
  className,
  style,
}) => {
  const { isEnabled, isSelected, toggle } = useBulkSelectionState(rowId);
  if (!isEnabled) return null;
  return (
    <BulkSelectCheckbox
      isSelected={isSelected}
      onChange={toggle}
      ariaLabel={ariaLabel}
      className={className}
      style={style}
    />
  );
};

export default BulkSelectCheckboxSlot;
